import { ReactNode } from 'react';

import { Box, Container, Grid, Stack } from 'ui';

import classes from './TicketsPageLayout.module.css';

interface TicketsPageLayoutProps {
  top?: ReactNode;
  title?: ReactNode;
  left?: ReactNode;
  right?: ReactNode;
}

const TicketsPageLayout = ({ top, title, left, right }: TicketsPageLayoutProps) => {
  return (
    <Container size="lg">
      <Grid columns={10} gutter="xl" justify="space-between" bg="white">
        {title && (
          <Grid.Col span={10} className={classes.TicketsPageLayout__title}>
            <Box>{title}</Box>
          </Grid.Col>
        )}

        {top && (
          <Grid.Col span={10}>
            <Box>{top}</Box>
          </Grid.Col>
        )}

        <Grid.Col span={{ base: 10, sm: 5 }}>
          <Stack className={classes.TicketsPageLayout__header}>
            {title && <Box visibleFrom="sm">{title}</Box>}
            {left || <Box />}
          </Stack>
        </Grid.Col>

        {right && (
          <Grid.Col span={{ base: 10, sm: 5 }}>
            <Box>{right}</Box>
          </Grid.Col>
        )}
      </Grid>
    </Container>
  );
};

export { TicketsPageLayout };
